import { writable, type Writable } from 'svelte/store';
import type { DeviceIncludeAssociateData } from 'src/types/NativeInclusionData';
import { stackedMobileEvents } from './ai-model';

export const inclusionStarted: Writable<boolean> = writable<boolean>(false);

export const inclusionState: Writable<{
	id?: number;
	type?: string;
	value?: string;
	raw_value?: string;
}> = writable(undefined);

export const inclusionStateCount: Writable<number> = writable<number>(0);

export const includeDeviceModal: Writable<{
	show: boolean;
	step: number;
	selected: {};
}> = writable<{ show: boolean; step: number; selected: {} }>({
	show: false,
	step: 0,
	selected: undefined,
});

includeDeviceModal.subscribe((value) => {
	if (!value.show) {
		stackedMobileEvents.set([]);
	}
});

// export const zendureModal: Writable<{ show: boolean, step: number, selected: {} }> = writable<{ show: boolean, step: number, selected: {} }>({ show: false, step: 0, selected: undefined });

export const discoveredBleDevices: Writable<{ [key: string]: any }> = writable({});

export const discoveredWiFiDevices: Writable<{}[]> = writable([]);

export const nonShellyNetworks: Writable<{}[]> = writable([]);

const createIncludingDeviceData = () => {
	const { subscribe, set, update }: Writable<DeviceIncludeAssociateData> = writable({});
	return {
		subscribe,
		setData: (data) => {
			set(data);
			return data;
		},
		updateData: (data) => {
			return update((old_data) => {
				data = { ...old_data, ...data };
				return data;
			});
		},
		reset: () => {
			return set({});
		},
	};
};

export const includingDeviceData = createIncludingDeviceData();

export type ZWavePendingAssociation = {
	dsk?: string;
	productId?: string;
	name?: string;
	/** Classic inclusion window (no SmartStart DSK yet). */
	manual?: boolean;
	gatewayId?: string;
};

export const zwavePendingAssociation: Writable<ZWavePendingAssociation | undefined> =
	writable(undefined);

const createAdvertisingBleDevices = () => {
	const { subscribe, set, update } = writable([]);

	return {
		subscribe,
		addClicked: (id) => {
			setTimeout(() => {
				advertisingBleDevices.removeClicked(id);
			}, 5000);
			update((s) => {
				s.push(id);
				return s;
			});
		},
		removeClicked: (id) => {
			update((s) => {
				s.splice(s.indexOf(id), 1);
				return s;
			});
		},
		reset: () => set([]),
	};
};

export const advertisingBleDevices = createAdvertisingBleDevices();
